<template>
  <AdminLayout>
    <Head title="Company Settings" />

    <!--        <div class="item -mt-5">-->
    <div class="headline flex flex-row justify-between mx-4 sm:mx-12">
      <h2 class="text-2xl font-semibold pb-5 pt-5 text-blue-600">Edit Company</h2>

      <div
        @click.prevent="save()"
        class="relative inline-flex shadow-sm rounded-md self-start mt-2"
      >
        <button
          :disabled="form.processing"
          type="button"
          class="inline-flex items-center px-4 py-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          Save Changes
        </button>
      </div>
    </div>

    <div class="form bg-gray-100 flex-1 py-10 px-4 sm:px-12">
      <form
        method="POST"
        @submit.prevent="save()"
      >
        <div class="sm:border-b sm:border-gray-400 sm:pb-5 sm:mb-5">
          <h3 class="text-lg leading-6 font-semibold text-blue-600">Company Detail</h3>
          <p class="mt-1 max-w-2xl text-sm text-gray-600">General company information used to define the instance.</p>
        </div>

        <div
          v-if="$page.props.flash.success"
          class="alert alert-success"
        >
          <p class="alert-text">
            {{ $page.props.flash.success }}
          </p>
        </div>

        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-8">
            <label for="name"> Company Name </label>
            <input
              type="text"
              v-model="form.name"
              name="name"
              id="name"
              autocomplete="given-name"
            />
            <p
              v-if="getErrors('name')"
              class="input-error"
            >
              {{ getErrors('name') }}
            </p>
          </div>

          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="phone"> License # </label>
            <input
              type="text"
              v-model="form.license_number"
              name="license_number"
              id="license_number"
            />
            <p
              v-if="getErrors('license_number')"
              class="input-error"
            >
              {{ getErrors('license_number') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="phone"> Phone </label>
            <input
              type="text"
              v-model="form.phone"
              name="phone"
              id="phone"
            />
            <p
              v-if="getErrors('phone')"
              class="input-error"
            >
              {{ getErrors('phone') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="email"> Email </label>
            <input
              type="text"
              v-model="form.email"
              name="email"
              id="email"
            />
            <p
              v-if="getErrors('email')"
              class="input-error"
            >
              {{ getErrors('email') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="website_url"> Website </label>
            <input
              type="text"
              v-model="form.website_url"
              name="website_url"
              id="website_url"
            />
            <p
              v-if="getErrors('website_url')"
              class="input-error"
            >
              {{ getErrors('website_url') }}
            </p>
          </div>
          <div class="input-group col-span-12 sm:col-span-12">
            <label for="address_1"> HQ Address 1 </label>
            <input
              type="text"
              v-model="form.address.street_1"
              name="address[address_1]"
              id="address_1"
              autocomplete="address_1"
            />
            <p
              v-if="getErrors('address.street_1')"
              class="input-error"
            >
              {{ getErrors('address.street_1') }}
            </p>
          </div>

          <div class="input-group col-span-12 sm:col-span-12">
            <label for="address_2"> HQ Address 2 </label>
            <input
              type="text"
              v-model="form.address.street_2"
              name="address[address_2]"
              id="address_2"
              autocomplete="address_2"
            />
            <p
              v-if="getErrors('address.street_2')"
              class="input-error"
            >
              {{ getErrors('address.street_2') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="city"> HQ City </label>
            <input
              type="text"
              v-model="form.address.city"
              name="address[city]"
              id="city"
            />
            <p
              v-if="getErrors('address.city')"
              class="input-error"
            >
              {{ getErrors('address.city') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="state"> HQ State </label>
            <select
              id="state"
              v-model="form.address.state"
              name="address[state]"
            >
              <option>Select a state</option>
              <option
                v-for="(state, key) in states"
                :value="key"
              >
                {{ state }}
              </option>
            </select>
            <p
              v-if="getErrors('address.state')"
              class="input-error"
            >
              {{ getErrors('address.state') }}
            </p>
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="zip"> HQ Zip </label>
            <input
              type="text"
              v-model="form.address.zip"
              name="address[zip]"
              id="zip"
            />
            <p
              v-if="getErrors('address.zip')"
              class="input-error"
            >
              {{ getErrors('address.zip') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="icon"> Icon </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.icon.click()"
                  type="text"
                  name="icon"
                  ref="iconalias"
                  id="icon"
                  class="file-upload w-full"
                  disabled
                  :value="company.icon_name"
                />
                <input
                  type="file"
                  ref="icon"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadIcon"
                  @input="form.icon = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!iconFile && !company.icon_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.icon.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="iconFile || company.icon_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeIcon"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.icon_url">
                    <img
                      :src="iconPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.icon.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="iconPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.icon_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('icon')"
              class="input-error"
            >
              {{ getErrors('icon') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="logo"> Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.logo.click()"
                  type="text"
                  name="logo"
                  ref="logoalias"
                  id="logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.logo_name"
                />
                <input
                  type="file"
                  ref="logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadLogo"
                  @input="form.logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!logoFile && !company.logo_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="logoFile || company.logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.logo_url">
                    <img
                      :src="logoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="logoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('logo')"
              class="input-error"
            >
              {{ getErrors('logo') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="logo"> Manifest Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.manifest_logo.click()"
                  type="text"
                  name="logo"
                  ref="manifest_logoalias"
                  id="manifest_logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.manifest_logo_name"
                />
                <input
                  type="file"
                  ref="manifest_logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadManifestLogo"
                  @input="form.manifest_logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!manifestLogoFile && !company.manifest_logo_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.manifest_logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="manifestLogoFile || company.manifest_logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.manifest_logo_url">
                    <img
                      :src="manifestLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.manifest_logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="manifestLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.manifeset_logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('manifest_logo')"
              class="input-error"
            >
              {{ getErrors('manifest_logo') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="top_sheet_logo"> Top Sheet Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.top_sheet_logo.click()"
                  type="text"
                  name="top_sheet_logo"
                  ref="top_sheet_logoalias"
                  id="top_sheet_logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.top_sheet_logo_name"
                />
                <input
                  type="file"
                  ref="top_sheet_logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadTopSheetLogo"
                  @input="form.top_sheet_logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!topSheetLogoFile && !company.top_sheet_logo_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.top_sheet_logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="topSheetLogoFile || company.top_sheet_logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeTopSheetLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.top_sheet_logo_url">
                    <img
                      :src="topSheetLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.top_sheet_logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="topSheetLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.top_sheet_logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('top_sheet_logo')"
              class="input-error"
            >
              {{ getErrors('top_sheet_logo') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="logo"> Receipt Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.receipt_logo.click()"
                  type="text"
                  name="logo"
                  ref="receipt_logoalias"
                  id="receipt_logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.receipt_logo_name"
                />
                <input
                  type="file"
                  ref="receipt_logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadReceiptLogo"
                  @input="form.receipt_logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!receiptLogoFile && !company.receipt_logo_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.receipt_logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="receiptLogoFile || company.receipt_logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeReceiptLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.receipt_logo_url">
                    <img
                      :src="receiptLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.receipt_logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="receiptLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.receipt_logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('receipt_logo')"
              class="input-error"
            >
              {{ getErrors('receipt_logo') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="logo"> Receipt Footer Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.receipt_footer_logo.click()"
                  type="text"
                  name="receipt_footer_logo"
                  ref="receipt_footer_logoalias"
                  id="receipt_footer_logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.receipt_footer_logo_name"
                />
                <input
                  type="file"
                  ref="receipt_footer_logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadReceiptFooterLogo"
                  @input="form.receipt_footer_logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!receiptFooterLogoFile && !company.receipt_footer_logo_url">
                  No file currently selected for upload.
                </p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.receipt_footer_logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="receiptFooterLogoFile || company.receipt_footer_logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeReceiptFooterLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.receipt_footer_logo_url">
                    <img
                      :src="receiptFooterLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.receipt_footer_logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="receiptFooterLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.receipt_footer_logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('receipt_footer_logo')"
              class="input-error"
            >
              {{ getErrors('receipt_footer_logo') }}
            </p>
          </div>

          <div class="input-group-file-upload col-span-12 sm:col-span-4">
            <label for="logo"> Sticker Logo </label>
            <div class="mt-1 relative rounded-md">
              <div
                class="inset-y-0 right-0 flex items-center position-relative"
                style="display: none"
              >
                <input
                  @click="$refs.sticker_logo.click()"
                  type="text"
                  name="logo"
                  ref="sticker_logoalias"
                  id="sticker_logo"
                  class="file-upload w-full"
                  disabled
                  :value="company.sticker_logo_name"
                />
                <input
                  type="file"
                  ref="sticker_logo"
                  class="file-upload"
                  accept="image/*"
                  @change="uploadStickerLogo"
                  @input="form.sticker_logo = $event.target.files[0]"
                  style="display: none"
                />
              </div>

              <div class="h-3">
                <p v-if="!stickerLogoFile && !company.sticker_logo_url">No file currently selected for upload.</p>
              </div>

              <div class="grid grid-cols-12 pt-3">
                <div class="col-span-8 sm:col-span-8 lg:col-span-8 text-sm">
                  <span
                    class="text-blue-600 text-sm font-semibold cursor-pointer pt-3 inline-block"
                    @click="$refs.sticker_logo.click()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Upload
                  </span>

                  <span
                    v-if="stickerLogoFile || company.sticker_logo_url"
                    class="text-red-600 text-sm font-semibold cursor-pointer pl-3 pt-3 inline-block"
                    @click="removeStickerLogo"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    | Remove
                  </span>
                </div>
                <div class="text-right col-span-4 sm:col-span-4 lg:col-span-4">
                  <div v-if="!company.sticker_logo_url">
                    <img
                      :src="stickerLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="$refs.sticker_logo.click()"
                    />
                  </div>
                  <div v-else>
                    <img
                      :src="stickerLogoPreview"
                      class="float-right object-contain h-24 _w-96 cursor-pointer"
                      @click="openImage(company.sticker_logo_url)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p
              v-if="getErrors('sticker_logo')"
              class="input-error"
            >
              {{ getErrors('sticker_logo') }}
            </p>
          </div>

          <div class="input-group col-span-12">
            <label for="receipt_footer_text"> Receipt Footer Text </label>
            <textarea
              v-model="form.receipt_footer_text"
              rows="5"
              type="text"
              id="receipt_footer_text"
              class="text-sm"
            />
            <p
              v-if="getErrors('receipt_footer_text', form)"
              class="input-error"
            >
              {{ getErrors('receipt_footer_text', form) }}
            </p>
          </div>
        </div>
      </form>
    </div>
    <!--        </div>-->
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'
import checksErrors from '@/Mixins/checksErrors'

export default {
  mixins: [checksErrors],

  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {
    company: Object
  },

  data() {
    return {
      form: {
        name: null,
        license_number: null,
        phone: null,
        email: null,
        website_url: null,
        address: {
          street_1: null,
          street_2: null,
          city: null,
          state: null,
          zip: null
        }
      },
      iconFile: '',
      iconPreview:
        this.company.icon_url === null ? '/images/placeholders/image-placeholder.png' : this.company.icon_url,
      /* In case we need to have separate placeholders for Icon and logo */
      logoFile: '',
      logoPreview:
        this.company.logo_url === null ? '/images/placeholders/image-placeholder.png' : this.company.logo_url,
      // Manifest logo
      manifestLogoFile: '',
      manifestLogoPreview:
        this.company.manifest_logo_url === null
          ? '/images/placeholders/image-placeholder.png'
          : this.company.manifest_logo_url,
      // Top Sheet logo
      topSheetLogoFile: '',
      topSheetLogoPreview:
        this.company.top_sheet_logo_url === null
          ? '/images/placeholders/image-placeholder.png'
          : this.company.top_sheet_logo_url,
      // Receipt logo
      receiptLogoFile: '',
      receiptLogoPreview:
        this.company.receipt_logo_url === null
          ? '/images/placeholders/image-placeholder.png'
          : this.company.receipt_logo_url,
      // Receipt footer logo
      receiptFooterLogoFile: '',
      receiptFooterLogoPreview:
        this.company.receipt_footer_logo_url === null
          ? '/images/placeholders/image-placeholder.png'
          : this.company.receipt_footer_logo_url,
      // Sticker logo
      stickerLogoFile: '',
      stickerLogoPreview:
        this.company.sticker_logo_url === null
          ? '/images/placeholders/image-placeholder.png'
          : this.company.sticker_logo_url,
      receipt_footer_text: null
    }
  },

  created() {
    this.form = useForm({
      ...this.form,
      ...(this.company || {}),
      ...{
        address: this.company.address || this.form.address
      }
    })
  },

  computed: {
    states() {
      return this.$page.props.util.states
    }
  },

  methods: {
    save() {
      this.form
        .transform((data) => {
          let payload = data

          /**
           * Remove string images if not newly uploaded files.
           * When just uploaded for submission, they will be File objects.
           */
          if (payload.icon && typeof payload.icon === 'string') {
            delete payload.icon
          }
          if (payload.logo && typeof payload.logo === 'string') {
            delete payload.logo
          }
          if (payload.manifest_logo && typeof payload.manifest_logo === 'string') {
            delete payload.manifest_logo
          }
          if (payload.top_sheet_logo && typeof payload.top_sheet_logo === 'string') {
            delete payload.top_sheet_logo
          }
          if (payload.receipt_logo && typeof payload.receipt_logo === 'string') {
            delete payload.receipt_logo
          }
          if (payload.receipt_footer_logo && typeof payload.receipt_footer_logo === 'string') {
            delete payload.receipt_footer_logo
          }
          if (payload.sticker_logo && typeof payload.sticker_logo === 'string') {
            delete payload.sticker_logo
          }

          return {
            _method: 'put',
            forceFormData: true,
            ...payload
          }
        })
        .post(this.route('company.update'), {
          onFinish: () => {}
        })
    },
    openImage(url) {
      if (!url) {
        return
      }

      window.open(url, '_blank')
    },
    uploadIcon(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.iconFile = files[0].name
      this.createIconPreview(files[0])
    },
    createIconPreview(file) {
      // var image = new Image();
      var reader = new FileReader()

      reader.onload = (e) => {
        this.iconPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeIcon() {
      this.iconPreview = '/images/placeholders/image-placeholder.png'
      this.iconFile = ''
      this.form.icon = ''
      this.company.icon_url = null

      this.$refs.iconalias.value = null
      this.$refs.icon = null
    },
    uploadLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.logoFile = files[0].name
      this.createLogoPreview(files[0])
    },
    createLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.logoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeLogo(e) {
      this.logoPreview = '/images/placeholders/image-placeholder.png'
      this.logoFile = ''
      this.form.logo = ''
      this.company.logo_url = null

      this.$refs.logoalias.value = null
      this.$refs.logo = null
    },
    uploadManifestLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.manifestLogoFile = files[0].name
      this.createManifestLogoPreview(files[0])
    },
    createManifestLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.manifestLogoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeManifestLogo(e) {
      this.manifestLogoPreview = '/images/placeholders/image-placeholder.png'
      this.manifestLogoFile = ''
      this.form.manifest_logo = ''
      this.company.manifest_logo_url = null

      this.$refs.manifest_logoalist.value = null
      this.$refs.manifest_logo = null
    },
    uploadTopSheetLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.topSheetLogoFile = files[0].name
      this.createTopSheetLogoPreview(files[0])
    },
    createTopSheetLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.topSheetLogoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeTopSheetLogo(e) {
      this.topSheetLogoPreview = '/images/placeholders/image-placeholder.png'
      this.topSheetLogoFile = ''
      this.form.top_sheet_logo = ''
      this.company.top_sheet_logo_url = null

      this.$refs.top_sheet_logoalist.value = null
      this.$refs.top_sheet_logo = null
    },
    uploadReceiptLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.receiptLogoFile = files[0].name
      this.createReceiptLogoPreview(files[0])
    },
    createReceiptLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.receiptLogoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeReceiptLogo(e) {
      this.receiptLogoPreview = '/images/placeholders/image-placeholder.png'
      this.receiptLogoFile = ''
      this.form.receipt_logo = ''
      this.company.receipt_logo_url = null

      this.$refs.receipt_logoalias.value = null
      this.$refs.receipt_logo = null
    },
    uploadReceiptFooterLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.receiptFooterLogoFile = files[0].name
      this.createReceiptFooterLogoPreview(files[0])
    },
    createReceiptFooterLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.receiptFooterLogoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeReceiptFooterLogo(e) {
      this.receiptFooterLogoPreview = '/images/placeholders/image-placeholder.png'
      this.receiptFooterLogoFile = ''
      this.form.receipt_footer_logo = ''
      this.company.receipt_footer_logo_url = null

      this.$refs.receipt_footer_logoalias.value = null
      this.$refs.receipt_footer_logo = null
    },
    uploadStickerLogo(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      this.stickerLogoFile = files[0].name
      this.createStickerLogoPreview(files[0])
    },
    createStickerLogoPreview(file) {
      var reader = new FileReader()

      reader.onload = (e) => {
        this.stickerLogoPreview = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeStickerLogo(e) {
      this.stickerLogoPreview = '/images/placeholders/image-placeholder.png'
      this.stickerLogoFile = ''
      this.form.sticker_logo = ''
      this.company.receipt_logo_url = null

      this.$refs.sticker_logoalias.value = null
      this.$refs.sticker_logo = null
    }
  }
}
</script>
